<template>
  <div class="ex-page">
    <div class="gs-page-hero">
      <div class="gs-hero-art is-experts" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>数据产业专家库</h1>
          <p>查找已公开的数据产业专家资料与研究方向。</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics">
        <div class="gs-page-hero-metric">
          <div class="metric-num"><em>{{ total }}</em></div>
          <div class="metric-label">位公开专家</div>
        </div>
      </div>
    </div>

    <div class="search-form">
      <div class="ds-search">
        <input
          v-model="queryFrom.name"
          class="ds-search-input"
          type="text"
          placeholder="搜索专家姓名、组织或研究方向"
          @keyup.enter="query"
        >
        <button type="button" class="ds-search-btn" @click="query">专家查一下</button>
      </div>
      <button
        v-if="isNarrow && labelList.length"
        type="button"
        class="ds-filter-toggle"
        @click="filtersOpen = !filtersOpen"
      >{{ filtersOpen ? '收起筛选' : '展开筛选' }}</button>
      <div
        v-if="labelList.length"
        class="filter-line"
        :class="{ 'is-collapsed': isNarrow && !filtersOpen }"
      >
        <span class="filter-label">擅长行业</span>
        <div class="filter-row">
          <span class="filter-chip filter-tag" :class="{ 'is-active': !queryFrom.specialtyDomain }" @click="setDomain('')">全部</span>
          <span
            v-for="item in visibleTags"
            :key="item.value"
            class="filter-chip filter-tag"
            :class="{ 'is-active': queryFrom.specialtyDomain === item.value }"
            @click="setDomain(item.value)"
          >{{ item.label }}</span>
        </div>
        <button v-if="labelList.length > 8" type="button" class="filter-expand" @click="tagsExpanded = !tagsExpanded">
          {{ tagsExpanded ? '收起' : '展开' }}
        </button>
      </div>
    </div>

    <div v-loading="loading" class="ds-table-wrap">
      <div class="ds-table">
        <div class="ds-head">
          <span class="c-name">专家名称</span>
          <span class="c-desc">专家介绍</span>
          <span class="c-num">行业类型</span>
          <span class="c-addr">组织 / 公司</span>
          <span class="c-area">地区</span>
          <span class="c-act">操作</span>
        </div>
        <div v-if="newsDetailData && newsDetailData.length" class="ds-body">
          <div v-for="row in newsDetailData" :key="row.id" class="ds-row-item">
            <span class="c-name" :title="row.name">{{ row.name || '—' }}</span>
            <span class="c-desc" :title="row.expertProfile"><em class="ds-k">介绍</em>{{ row.expertProfile || '暂无介绍' }}</span>
            <span class="c-num"><em class="ds-k">行业</em>{{ transFormEnum(labelList, row.specialtyDomain) || '—' }}</span>
            <span class="c-addr" :title="row.enterpriseName"><em class="ds-k">组织</em>{{ row.enterpriseName || '—' }}</span>
            <span class="c-area" :title="row.areaName"><em class="ds-k">地区</em>{{ row.areaName || '—' }}</span>
            <span class="c-act">
              <button type="button" class="ds-link" @click="detailRow(row)">详情</button>
            </span>
          </div>
        </div>
        <div v-else class="ds-empty">暂无数据</div>
      </div>
      <div class="table-pagination">
        <GsPagination
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getExpertList } from '@/api/api.js'
import { enumType } from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import GsPagination from '@/components/GsPagination/index.vue'
import { P } from '@/router/paths'
export default {
  name: 'InterViewList',
  components: { GsPagination },
  data() {
    return {
      title: (this.$route.meta && this.$route.meta.title) || '',
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      newsDetailData: [],
      labelList: [],
      tagsExpanded: false,
      filtersOpen: false,
      isNarrow: typeof window !== 'undefined' && window.innerWidth < 960,
      queryFrom: {
        name: '',
        specialtyDomain: '',
        areaName: ''
      }
    }
  },
  computed: {
    visibleTags() {
      const list = this.labelList || []
      return this.tagsExpanded ? list : list.slice(0, 8)
    },
    transFormEnum() {
      return function (enumList, value, multi) {
        if (!value) return ''
        let valObj = []
        try {
          valObj = multi ? JSON.parse(value) : String(value).split(',').map((item) => item.trim())
        } catch (e) {
          valObj = String(value).split(',').map((item) => item.trim())
        }
        const labels = []
        ;(enumList || []).forEach((item) => {
          valObj.forEach((itemObj) => {
            if (String(itemObj) === String(item.value)) labels.push(item.label)
          })
        })
        return labels.join('、')
      }
    }
  },
  mounted() {
    this.syncNarrow()
    window.addEventListener('resize', this.syncNarrow)
    window.scrollTo(0, 0)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncNarrow)
  },
  created() {
    this.getExpertList()
    this.getData('sys_expert_specialty_domain')
  },
  methods: {
    syncNarrow() {
      this.isNarrow = typeof window !== 'undefined' && window.innerWidth < 960
      if (!this.isNarrow) this.filtersOpen = false
    },
    query() {
      this.currentPage = 1
      this.getExpertList()
    },
    setDomain(value) {
      const next = value || ''
      this.queryFrom.specialtyDomain = this.queryFrom.specialtyDomain === next ? '' : next
      this.currentPage = 1
      this.getExpertList()
    },
    async getData(type) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0 && type === 'sys_expert_specialty_domain') {
          this.labelList = enumType(res.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    getExpertList() {
      this.loading = true
      getExpertList({
        currentPage: this.currentPage,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        publishStatus: 1,
        handleStatus: 1,
        name: this.queryFrom.name || null,
        specialtyDomain: this.queryFrom.specialtyDomain || null,
        areaName: this.queryFrom.areaName || null
      }).then((response) => {
        this.loading = false
        this.newsDetailData = (response && response.rows) || []
        this.total = (response && response.total) || 0
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getExpertList()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    detailRow(row) {
      this.$router.push(P.expertDetail(row.id))
    }
  }
}
</script>
<style lang="css" scoped>
.ex-page {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0 32px;
  color: #1d2b44;
  overflow: visible;
}
.ex-page .gs-page-hero {
  margin-bottom: 18px;
}
.search-form {
  width: min(var(--gs-main-width, 1250px), 100%);
  margin: 0 auto 18px;
  background: #F2F6FB;
  border-radius: 12px;
  padding: 16px 20px 10px;
  box-sizing: border-box;
}
.ds-search {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.ds-search-input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  border: 1px solid #D7DEE8;
  border-right: 0;
  border-radius: 4px 0 0 4px;
  padding: 0 14px;
  outline: none;
  background: #fff;
  font-family: inherit;
  font-size: 14px;
  color: #1f2937;
}
.ds-search-input::placeholder {
  font-family: inherit;
  color: #8A96A8;
}
.ds-search-input:focus {
  border-color: #0165FF;
}
.ds-search-btn {
  flex: 0 0 auto;
  height: 40px;
  padding: 0 18px;
  border: 0;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, #9CC8FF 0%, #4D94FF 42%, #0165FF 86%, #0050CC 100%);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}
.filter-line {
  display: flex;
  align-items: center;
  gap: 10px 16px;
  padding: 7px 0;
  min-width: 0;
}
.filter-label {
  flex: 0 0 72px;
  color: #333;
  font-size: 14px;
  line-height: 32px;
  white-space: nowrap;
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  flex: 1;
  min-width: 0;
}
.filter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  background: #D7E6FF;
  color: #0165FF;
  cursor: pointer;
  font-size: 14px;
}
.filter-chip.filter-tag.is-active {
  color: #fff;
  background: linear-gradient(180deg, #9CC8FF 0%, #4D94FF 42%, #0165FF 86%, #0050CC 100%);
}
.filter-expand {
  margin-left: auto;
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #0165FF;
  font-size: 14px;
  cursor: pointer;
}
.ds-k { display: none; }
.ds-table-wrap {
  width: min(var(--gs-main-width, 1250px), 100%);
  margin: 0 auto;
  background: #fff;
  border-radius: 14px;
  padding: 0 0 8px;
  box-sizing: border-box;
}
.ds-table {
  width: 100%;
  background: #fff;
  border: 1px solid #D7E6FF;
  border-radius: 12px;
  overflow: hidden;
}
.ds-head,
.ds-row-item {
  display: grid;
  grid-template-columns: 1.1fr 2fr 1fr 1.3fr 0.9fr 88px;
  gap: 10px;
  align-items: center;
  padding: 0 18px;
}
.ds-head {
  height: 54px;
  background: linear-gradient(180deg, #EAF3FF 0%, #D7E6FF 100%);
  color: #0165FF;
  font-size: 15px;
  font-weight: 700;
}
.ds-row-item {
  min-height: 68px;
  border-top: 1px solid #EEF3F8;
  font-size: 15px;
  color: #334155;
}
.ds-row-item:nth-child(even) { background: #F8FBFF; }
.ds-row-item:hover { background: #EEF5FF; }
.c-name {
  font-size: 16px;
  font-weight: 700;
  color: #0B1F3A;
}
.c-name, .c-desc, .c-addr, .c-area, .c-num {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ds-empty {
  padding: 56px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}
.ds-link {
  height: 32px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: #0165FF;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}
.table-pagination { margin-top: 16px; }
@media (max-width: 960px) {
  .ex-page .gs-page-hero {
    margin-bottom: 12px;
  }
  .search-form, .ds-table-wrap { width: calc(100% - 24px); }
  .search-form {
    padding: 12px;
    margin-bottom: 12px;
  }
  .ds-search-input,
  .ds-search-btn {
    height: 36px;
    font-size: 13px;
  }
  .ds-filter-toggle {
    display: block;
    width: 100%;
    height: 32px;
    margin: 0 0 8px;
    border: 1px dashed #B8C9E0;
    border-radius: 6px;
    background: #fff;
    color: #0165FF;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
  }
  .filter-line.is-collapsed {
    display: none;
  }
  .filter-label { font-size: 12px; }
  .filter-chip { height: 28px; padding: 0 10px; font-size: 12px; }
  .ds-head { display: none; }
  .ds-body { display: flex; flex-direction: column; gap: 10px; }
  .ds-table { border: 0; background: transparent; overflow: visible; }
  .ds-row-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    min-height: 0;
    padding: 14px;
    background: #fff;
    border: 1px solid #E4E7ED;
    border-radius: 10px;
    font-size: 12px;
  }
  .c-name {
    font-size: 15px;
    white-space: normal;
  }
  .c-name, .c-desc, .c-addr, .c-area, .c-num {
    white-space: normal;
  }
  .ds-k { display: inline; margin-right: 6px; color: #7B889C; }
  .c-act { align-self: flex-end; }
  .ds-link {
    height: 28px;
    padding: 0 12px;
    font-size: 12px;
  }
}
</style>
